import { render, staticRenderFns } from "./NoticeLetterCreationModal.vue?vue&type=template&id=f148db9a&scoped=true&"
import script from "./NoticeLetterCreationModal.vue?vue&type=script&lang=ts&"
export * from "./NoticeLetterCreationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f148db9a",
  null
  
)

export default component.exports